// import Vue from 'vue'
// import Toast from 'vue-toastification'
// import 'vue-toastification/dist/index.css'
// import router from '../router/index'
import { EventBus } from '@/helpers/eventBus'

// Vue.use(Toast)
// const toast = Vue.$toast

const getCookieValue = (name) => {
  const cookies = document.cookie.split('; ')
  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=')
    if (cookieName === name) {
      return decodeURIComponent(cookieValue)
    }
  }
  return null // Return null if the cookie is not found
}

const showErrorMessage = (msg) => {
  // toast.error(`${msg}`)
}

const unAuthorized = () => {
  EventBus.$emit('session-expired')
  // router.push('/')
}

export { getCookieValue, showErrorMessage, unAuthorized }
